import React from 'react';
import { translateModalId } from '../../../common/modals/translateModal/TranslateModal';
import { remoteModalsActions } from '../../../../../store/remoteModalsSlice';
import store from '../../../../../store';
import useFieldLabelPropsSelector from './useFieldLabelPropsSelector';
import { useApiaComponentContext } from '../../apiaComponent/ApiaComponentContext';
import { parseFakeJSON } from '.';
import { useApiaFormContext } from '../../page/ApiaForm';
import usePropsSelector from '../../../../../store/propsStore/usePropsSelector';
import validationsStore from '../../../../../store/validation/validationStore';
import { translationActions } from '../../../../../store/translationSlice';
import {
  ILanguageState,
  parseFieldXmlTrad,
} from '../../../common/modals/translateModal/LanguagesList';

export default function useTranslationProps({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  const fieldProps = useApiaComponentContext();
  const formProps = useApiaFormContext();
  const langs = parseFakeJSON(formProps.formData.langs ?? '');

  const {
    type,
    fieldValue,
    valueType,
    isLangs,
    frmParent,
    isReadonly,
    isDisabled,
    isShowAsText,
    qryId,
  } = useFieldLabelPropsSelector();

  const shouldShowTranslateButton =
    isLangs &&
    !isReadonly &&
    !isDisabled &&
    !isShowAsText &&
    frmParent === 'E' &&
    valueType === 'S' &&
    !qryId &&
    fieldValue &&
    (type === 'area' || type === 'editor' || type === 'input');
  const onClickTranslate = React.useCallback(() => {
    store.dispatch(
      remoteModalsActions.open({
        id: translateModalId,
        data: {
          fieldId: fieldProps.fieldId,
          langs,
          label,
          children,
          open: false,
          modalProps: {
            sx: {
              '.modal__main ': {
                resize: 'none',
              },
            },
          },
        },

        size: type === 'editor' || type === 'area' ? 'xxxl' : 'flex',

        title: window.TIT_TRANSLATION,
      }),
    );
  }, [children, fieldProps.fieldId, label, langs, type]);

  const initTranslations = () => {
    const initialTranslations = parseFieldXmlTrad(fieldProps.field?.trad ?? '');
    store.dispatch(
      translationActions.setState({
        id: fieldProps.fieldId,
        langs: langs.map((lang) => {
          return {
            ...lang,
            fieldId: lang.id,
            isTranslated:
              initialTranslations.find(
                (c: { id: string; label: string }) =>
                  String(c.id) === String(lang.id),
              )?.label === 'true',
          };
        }) as unknown as ILanguageState[],

        selectedLanguage: null,
      }),
    );
  };

  const previousValue = React.useRef<unknown>(null);
  usePropsSelector(
    fieldProps.fieldId,
    function deleteTranslationsOnDeleteFieldValue(props) {
      if (props.value === '' && props.value !== previousValue.current) {
        validationsStore.unregisterForm(`translation${fieldProps.fieldId}`);
        setTimeout(() => {
          store.dispatch(
            translationActions.setState({
              id: fieldProps.fieldId,
              langs: langs.map((current) => {
                return {
                  ...current,
                  fieldId: current.id,
                  currentValue: '',
                  hasQueriedServer: false,
                  isTemporalyTranslated: false,
                  isTranslated: false,
                };
              }) as unknown as ILanguageState[],

              selectedLanguage: null,
            }),
          );
        }, 0);
      }
      previousValue.current = props.value;
    },
  );

  return { shouldShowTranslateButton, onClickTranslate, initTranslations };
}
